import {
  ADMIN_DOCTORS_LIST_REQUEST,
  ADMIN_DOCTORS_LIST_SUCCESS,
  ADMIN_DOCTORS_LIST_FAIL,
  ADMIN_DOCTOR_ADD_REQUEST,
  ADMIN_DOCTOR_ADD_SUCCESS,
  ADMIN_DOCTOR_ADD_FAIL,
  ADMIN_DOCTOR_UPDATE_REQUEST,
  ADMIN_DOCTOR_UPDATE_SUCCESS,
  ADMIN_DOCTOR_UPDATE_FAIL,
  ADMIN_DOCTOR_DELETE_REQUEST,
  ADMIN_DOCTOR_DELETE_SUCCESS,
  ADMIN_DOCTOR_DELETE_FAIL,
} from "../../constants/adminConstants/doctorConstants";

export const adminDoctorsReducer = (state = { doctors: [] }, action) => {
  switch (action.type) {
    case ADMIN_DOCTORS_LIST_REQUEST:
    case ADMIN_DOCTOR_ADD_REQUEST:
    case ADMIN_DOCTOR_UPDATE_REQUEST:
    case ADMIN_DOCTOR_DELETE_REQUEST:
      return { ...state, loading: true };

    case ADMIN_DOCTORS_LIST_SUCCESS:
      return { loading: false, doctors: action.payload };

    case ADMIN_DOCTOR_ADD_SUCCESS:
    case ADMIN_DOCTOR_UPDATE_SUCCESS:
    case ADMIN_DOCTOR_DELETE_SUCCESS:
      return { ...state, loading: false };

    case ADMIN_DOCTORS_LIST_FAIL:
    case ADMIN_DOCTOR_ADD_FAIL:
    case ADMIN_DOCTOR_UPDATE_FAIL:
    case ADMIN_DOCTOR_DELETE_FAIL:
      return { ...state, loading: false, error: action.payload };

    default:
      return state;
  }
};
